module.exports = __webpack_public_path__ + "static/media/Gautam Sanka.34ab2d1c.png";